var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhiteRighArrow = function SvgWhiteRighArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.62,
    height: 11.016,
    viewBox: "0 0 13.62 11.016",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_685132_cc",
    transform: "translate(13.094 0.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10143",
    "data-name": "Group 10143",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M4.8.069.086,4.5A.284.284,0,0,0,.073,4.9a.291.291,0,0,0,.394.013L4.71.918v11.4a.277.277,0,0,0,.554,0V.918L9.506,4.909A.29.29,0,0,0,9.9,4.9.281.281,0,0,0,9.887,4.5L5.177.069a.3.3,0,0,0-.381,0Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteRighArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteRighArrow.1aa643c9.svg";
export { ForwardRef as ReactComponent };